import { useEffect } from "react";
import './Index.css'

function Index() {
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        console.log(data.country_name, data.country_code);
        switch (data.country_code) {
          case "CO":
            window.location.href = "/co";
            break;
          case "ES":
            window.location.href = "/es";
            break;
          default:
            window.location.href = "/en";
            break;
        }
      })
      .catch(() => {
        window.location.replace("/us");
      });
  }, []);

  return null;
}

export default Index;

